import React from 'react';

const CategoryNav = ({
  categories,
  categoryCounts,
  selectedCategory,
  expandedCategories,
  onCategoryClick,
  onToggleExpand
}) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="baiql-category-nav">
      <div className="baiql-category-nav-header">Categories</div>
      <div className="baiql-category-nav-list">
        {categories.map((category) => {
          const count = categoryCounts.get(category) || 0;
          const isExpanded = expandedCategories.has(category);
          const isSelected = selectedCategory === category;

          return (
            <div key={category} className="baiql-category-nav-item">
              <button
                className={`baiql-category-nav-button ${isSelected ? 'active' : ''}`}
                onClick={() => onCategoryClick(category)}
              >
                <span
                  className="baiql-category-nav-toggle"
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggleExpand(category);
                  }}
                >
                  {isExpanded ? '▼' : '▶'}
                </span>
                <span className="baiql-category-nav-name">{category}</span>
                <span className="baiql-category-nav-count">({count})</span>
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryNav;

